/* Derby PLP size availability (2026-09-13).
   The size run is printed by snippets/derby-card-sizes.liquid inside the card MEDIA wrapper
   (the only guaranteed per-card hook), hidden. This moves each one into that card's
   .hdt-card-product__info so it renders under the price instead of overlaying the photo and
   colliding with .derby-offers. MutationObserver re-runs it for infinite-scroll pages. */
(function () {
  if (window.__drbyCS) return;
  window.__drbyCS = 1;

  function move(root) {
    var nodes = (root || document).querySelectorAll('.drby-cs[hidden]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var card = el.closest('.hdt-card-product');
      if (!card) continue;
      var info = card.querySelector('.hdt-card-product__info');
      if (!info) continue;
      info.appendChild(el);
      el.removeAttribute('hidden');
    }
  }

  function ready(fn) {
    document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    move();
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        if (recs[i].addedNodes && recs[i].addedNodes.length) {
          if (!pending) { pending = true; requestAnimationFrame(function () { pending = false; move(); }); }
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
